import { useCallback, useEffect, useState } from 'react'
import {
  fetchActiveWorkOverviewFromFirestore,
  type ActiveWorkOverviewData,
} from '../services/pwfProfitabilitySnapshotService'

export function useActiveWorkOverview() {
  const [data, setData] = useState<ActiveWorkOverviewData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const overview = await fetchActiveWorkOverviewFromFirestore()
      setData(overview)
    } catch (err) {
      setData(null)
      setError(err instanceof Error ? err.message : 'Failed to load active work overview')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void reload()
  }, [reload])

  return { data, loading, error, reload }
}
